// ** Gatsby
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Button from "../Button"
import CardContainer from "../CardContainer"
import Container from "../Container"
import Heading from "../Heading"
import SwiperSlider from "../SwiperSlider"
import Text from "../Text"

import { parseLink } from "../../utils/helpers"

const SectionProductCards = ({ section }: any) => {
  const { label, title, subTitle, listItems } = section
  return (
    <Container constrainedToBreakPoint className="lg:w-full pl-0 mb-0 pb-0">
      <Box className="w-full max-w-full mt-12 flex justify-center items-center gap-6 flex-wrap">
        {listItems.map((item: any, idx: any) => (
          <Link
            key={idx}
            to={parseLink(item.linkPrimary)}
            className="relative w-[400px]"
          >
            <CardContainer
              forceHeight={false}
              header={
                <GatsbyImage
                  image={item.Image?.asset?.gatsbyImageData}
                  alt={item.Image?.asset?.altText || "features"}
                  className="rounded-t-[20px] lg:h-36"
                />
              }
            >
              <Box className="flex flex-col h-[250px] text-center">
                <Heading as="h4" className="text-blue-500 mb-8">
                  {item.title}
                </Heading>
                <Box className="flex overflow-auto scrollbar-hide">
                  <Text variant="body-copy">{item.value}</Text>
                </Box>
              </Box>
            </CardContainer>
          </Link>
        ))}
      </Box>
    </Container>
  )
}

export default SectionProductCards
